import axios from 'axios'

import {
  GetQuestionnaireResponse,
  GetQuestionnaireStatsResponse
} from 'src/api/requests'
import { parseToken } from 'src/utils'

export const getPercentage = (
  responses: number = 0,
  totalResponses: number = 0
) => {
  const percentage = totalResponses > 0 ? (responses / totalResponses) * 100 : 0

  return parseFloat(percentage.toFixed(2))
}

export const mapAnswersToQuiz = (
  quiz?: GetQuestionnaireResponse,
  selectedAnswers?: GetQuestionnaireStatsResponse
) => {
  return {
    ...quiz,
    questions: quiz?.questions?.map((question) => {
      const totalResponses = question?.answerChoices?.reduce((sum, choice) => {
        const choiceId = choice.id

        return (
          sum + ((choiceId && selectedAnswers?.answers?.[choiceId]?.count) || 0)
        )
      }, 0)

      const answerChoices = [
        ...(question?.answerChoices?.map((choice) => {
          const choiceId = choice.id

          return {
            ...choice,
            count: choiceId
              ? (selectedAnswers?.answers?.[choiceId]?.count ?? 0)
              : 0
          }
        }) ?? []),
        ...(question.otherChoiceId &&
        selectedAnswers?.answers?.[question.otherChoiceId]?.count
          ? [
              {
                id: 'other',
                text: { ru: 'Другой', ro: 'Altul' },
                count: selectedAnswers.answers[question.otherChoiceId].count
              }
            ]
          : [])
      ]

      return {
        ...question,
        answerChoices,
        totalResponses:
          (totalResponses ?? 0) +
          (question.otherChoiceId
            ? (selectedAnswers?.answers?.[question.otherChoiceId]?.count ?? 0)
            : 0)
      }
    })
  }
}

export const getPreview = async (id?: string): Promise<string> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/api/media/${id}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${parseToken(localStorage.getItem('access_token'))}`
        }
      }
    )

    const url = window.URL.createObjectURL(
      new Blob([response?.data as BlobPart])
    )

    return url
  } catch {
    return ''
  }
}
